(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["canny-collar-size-finder"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root) return;

    var input = root.querySelector('.canny-size-finder__input');
    var unitButtons = root.querySelectorAll('[data-unit]');
    var calcBtn = root.querySelector('[data-action="calc"]');
    var resetBtn = root.querySelector('[data-action="reset"]');
    var resultWrap = root.querySelector('.canny-size-finder__result');
    var resultEl = root.querySelector('[data-result]');
    var noteEl = root.querySelector('[data-note]');

    var rangesEl = root.querySelector('[data-ranges]');
    var ranges;
    try {
      ranges = JSON.parse(rangesEl.textContent);
    } catch (e) {
      console.error('Canny size finder: invalid ranges JSON', e);
      return;
    }

    var unit = 'cm';

    function setUnit(nextUnit) {
      unit = nextUnit;
      unitButtons.forEach(function (b) {
        var active = b.getAttribute('data-unit') === unit;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function parseNumber(v) {
      var cleaned = String(v || '').trim().replace(',', '.');
      cleaned = cleaned.replace(/[^0-9.\-]/g, '');
      var n = Number(cleaned);
      return Number.isFinite(n) ? n : null;
    }

    function inchesToCm(inches) { return inches * 2.54; }

    function findSizeByCm(cm) {
      for (var i = 0; i < ranges.length; i++) {
        var r = ranges[i];
        if (cm >= r.min && cm <= r.max) return r;
      }
      return null;
    }

    function showResult(text, note) {
      resultEl.innerHTML = text;
      noteEl.innerHTML = note || '';
      resultWrap.hidden = false;
    }

    function hideResult() {
      resultWrap.hidden = true;
      resultEl.innerHTML = '';
      noteEl.innerHTML = '';
    }

    function calculate() {
      hideResult();

      var n = parseNumber(input.value);
      if (n === null) return showResult("<span class='canny-static'>Please enter a number</span>.", "<span class='canny-static'>Example</span>: 34.5");
      if (n <= 0) return showResult("<span class='canny-static'>Please enter a neck size greater than zero</span>.");

      var cm = (unit === 'cm') ? n : inchesToCm(n);
      var cmDisplay = Math.round(cm * 10) / 10;

      var match = findSizeByCm(cm);
      if (!match) {
        var min = ranges[0].min;
        var max = ranges[ranges.length - 1].max;
        return showResult("<span class='canny-static'>No match found</span>.", "<span class='canny-static'>Converted</span>: " + cmDisplay + "<span class='canny-static'>cm</span>. <span class='canny-static'>Chart covers</span> " + min + "–" + max + "<span class='canny-static'>cm</span>.");
      }

      var boundaryNote = '';
      for (var i = 1; i < ranges.length; i++) {
        var boundary = ranges[i].min;
        if (Math.abs(cm - boundary) < 1e-9) {
          boundaryNote = " <span class='canny-static'>You’re exactly between sizes</span> (" + boundary + "<span class='canny-static'>cm</span>). <span class='canny-static'>We usually recommend the smaller size for the best fit</span>.";
          break;
        }
      }

      // Updated line below: Colon is now outside the span
      var baseNote = (unit === 'in') 
        ? ("<span class='canny-static'>That’s about</span> " + cmDisplay + "<span class='canny-static'>cm</span>.") 
        : ("<span class='canny-static'>Measured</span>: " + cmDisplay + "<span class='canny-static'>cm</span>.");
        
      showResult(match.label, baseNote + boundaryNote);
    }

    unitButtons.forEach(function (b) {
      b.addEventListener('click', function () {
        setUnit(b.getAttribute('data-unit'));
        hideResult();
        input.focus();
      });
    });

    calcBtn.addEventListener('click', calculate);

    resetBtn.addEventListener('click', function () {
      input.value = '';
      setUnit('cm');
      hideResult();
      input.focus();
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') calculate();
    });

    setUnit('cm');
  }

  document.querySelectorAll('[data-canny-size-finder]').forEach(init);
})();

  } catch(e) { console.error(e); }
})();
})();
